module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA4.c6c8e998.jpg";